import heroImage from "@/assets/hero-family.jpg";
import { useTranslation } from 'react-i18next';

export const Hero = () => {
  const { t } = useTranslation();
  
  return (
    <section id="home" className="relative h-[600px] md:h-[680px] flex items-end justify-center overflow-hidden pb-16 scroll-mt-20" aria-labelledby="hero-heading">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Happy family at home"
          width={1920}
          height={1080}
          fetchPriority="high"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-hero-overlay/60"></div>
      </div>

      {/* Content */}
      <div className="relative container mx-auto px-4 z-10">
        <div className="max-w-3xl">
          <h1 id="hero-heading" className="text-3xl md:text-4xl lg:text-5xl font-bold text-white/70 mb-6 leading-tight">
            {t('hero.subtitle')}
          </h1>
        </div>
      </div>
    </section>
  );
};
